import PropTypes from 'prop-types';
import BannerItem from './BannerItem.js';

function Banner({ selected }) {
  return (
    <div className="banner">
      <BannerItem
        text="Hello"
        left
        selected={selected === 'about'}
        href="/about"
      />
      <BannerItem text="Music" selected={selected === 'music'} href="/music" />
      <BannerItem
        text="Resume"
        selected={selected === 'resume'}
        href="/resume"
      />
      <BannerItem
        text="Contact"
        selected={selected === 'contact'}
        href="/contact"
      />
    </div>
  );
}

Banner.propTypes = {
  selected: PropTypes.string
};

export default Banner;
